const substractNumbers = (a, b) => {
	let c = a - b
	console.log(`${a} - ${b} = ${c}`)
	return c
}
export default substractNumbers
